import { render } from "./_Grades.vue?vue&type=template&id=190cda15"
import script from "./_Grades.vue?vue&type=script&lang=js"
export * from "./_Grades.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__